var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03809 6.69917C4.03809 10.2626 6.93682 13.1617 10.4999 13.1617C14.0633 13.1617 16.9623 10.2626 16.9623 6.69917C16.9623 3.13617 14.0633 0.237427 10.4999 0.237427C6.93688 0.237427 4.03809 3.1361 4.03809 6.69917ZM6.11981 6.69917C6.11981 4.28404 8.08469 2.31915 10.4999 2.31915C12.9154 2.31915 14.8806 4.28404 14.8806 6.69917C14.8806 9.11476 12.9154 11.08 10.4999 11.08C8.08469 11.08 6.11981 9.11476 6.11981 6.69917Z",
    fill: "#272726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46179 27.2362H14.5382C18.1013 27.2362 21 24.3374 21 20.7744C21 17.2113 18.1013 14.3126 14.5382 14.3126H6.46179C2.89879 14.3126 0 17.2113 0 20.7744C0 24.3374 2.89873 27.2362 6.46179 27.2362ZM2.08172 20.7744C2.08172 18.3592 4.0466 16.3943 6.46179 16.3943H14.5382C16.9534 16.3943 18.9183 18.3592 18.9183 20.7744C18.9183 23.1896 16.9534 25.1545 14.5382 25.1545H6.46179C4.0466 25.1545 2.08172 23.1896 2.08172 20.7744Z",
    fill: "#272726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.851406368b5d72ff4000109be70c82fa.svg";
export { ForwardRef as ReactComponent };